import { animate, style, transition, trigger } from '@angular/animations';

const FADE_ANIMATION_NAME = 'fade';

export const fadeAnimation = trigger(FADE_ANIMATION_NAME, [
    transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms ease-out', style({ opacity: 1 })),
    ]),
]);
